function globalCustomStartRating(ratingElement, selector) {
  if (ratingElement) {
    return new Promise((resolve) => {
      if (ratingElement.querySelector(selector)) {
        return resolve(ratingElement.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (ratingElement.querySelector(selector)) {
          resolve(ratingElement.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}

try {
  const getAllRatingsElements = document.querySelectorAll('.card-star-rating');
  getAllRatingsElements.forEach(ratingElement => {

    globalCustomStartRating(ratingElement, '.yotpo-display-wrapper').then((currentRating) => {
      let wrapper = document.createElement('div');
      let averageRating = document.createElement('span');
      let star = document.createElement('span');

      star.innerHTML = `<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 1.5L7.545 4.63L11 5.135L8.5 7.57L9.09 11.01L6 9.385L2.91 11.01L3.5 7.57L1 5.135L4.455 4.63L6 1.5Z" fill="#FFCD3C" stroke="#FFCD3C" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`

      averageRating.textContent = `
          ${parseFloat(currentRating.querySelector('.sr-only').textContent)}
          (${parseFloat(currentRating.querySelector('.text-m').textContent)})
    `;
      wrapper.className = 'product-card-rating'
      wrapper.append(star, averageRating)
      ratingElement.append(wrapper);
    });
  })
} catch (error) {
  console.log(error)
}


try {
  const pdpStarRating = document.querySelector('.pdp-star-rating');
  globalCustomStartRating(pdpStarRating, '.yotpo-stars').then((element) => {
    const currentRating = parseFloat(element.textContent);

    if (currentRating == 0) {
      document.querySelector('.template-product__stars').style.display = 'none';
    }

    element.innerHTML = '';
    renderNumber(element)

    for (let index = 0; index < parseInt(currentRating); index++) {
      renderStar(element, 100, index);
    }

    if ((currentRating % 1).toFixed(1) > 0.3 && (currentRating % 1).toFixed(1) < 0.8) {
      renderStar(element, 50, parseInt(currentRating));
    } else if ((currentRating % 1).toFixed(1) > 0.7) {
      renderStar(element, 100, parseInt(currentRating));
    }

    function renderStar(element, fill, index) {
      element.innerHTML +=
        `
          <svg width="0" height="0">
            <defs>
              <linearGradient id="${index}half-gradient" x1="0" x2="1" y1="0" y2="0">
                <stop offset="${fill}%" stop-color="#FFCD3C" />
                <stop offset="${fill}%" stop-color="#D3D3D3" />
              </linearGradient>
              <linearGradient id="${index}half-stroke-gradient" x1="0" x2="1" y1="0" y2="0">
                <stop offset="${fill}%" stop-color="#FFCD3C" />
                <stop offset="${fill}%" stop-color="#D3D3D3" />
              </linearGradient>
            </defs>
          </svg>

          <svg class="rating-custom-star" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 1.5L7.545 4.63L11 5.135L8.5 7.57L9.09 11.01L6 9.385L2.91 11.01L3.5 7.57L1 5.135L4.455 4.63L6 1.5Z" fill="url(#${index}half-gradient)" stroke="url(#${index}half-stroke-gradient)" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
    }

    function renderNumber(element) {
      let number = document.createElement('span');
      number.textContent = currentRating;
      number.className = 'rating-custom-number'
      element.prepend(number);
    }

  });
} catch (error) {
  console.log(error);
}

